<h3 mat-dialog-title>
  {{ data?.title || 'Commentaire' }}
</h3>
<mat-dialog-content>
  <mat-form-field class="w-100">
    <mat-label>Commentaire</mat-label>
    <textarea
      matInput
      [(ngModel)]="comment"
      cdkTextareaAutosize
      cdkAutosizeMinRows="3"
      cdkAutosizeMaxRows="5"
      [required]="data?.required ?? false"
    ></textarea>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="dialogRef.close()">Fermer</button>
  <app-save-button
    (click)="onOk()"
    [isEditMode]="false"
    [enabled]="isValid"
    matTooltip=""
  ></app-save-button>
</mat-dialog-actions>
